export const repairTypeEnum = [
  {id: 'REPAIR', label: 'oprava'},
  {id: 'MAINTENANCE', label: 'údržba'},
];

export enum RepairType {
  MAINTENANCE = 'MAINTENANCE',
  REPAIR = 'REPAIR',
}

export const historyActionEnum = [
  { id: 'CREATED', label: 'vytvořena' },
  { id: 'UPDATED', label: 'změněna' },
  { id: 'DELETED', label: 'smazána' },
];


// WEBPACK FOOTER //
// ./src/modules/repairs/_repairsEnums.ts